export var CORES_STATUS_SOLICITACAO = {
    1: {
        pure: {
            color: "#3B84FF",
            textColor: "#000000"
        },
        medium: {
            color: "#7EB3FF",
            textColor: "#000000"
        },
        dark: {
            color: "#0058CB",
            textColor: "#ffffff"
        },
        light: {
            color: "#BFD7FF",
            textColor: "#000000"
        }
    },
    2: {
        pure: {
            color: "#FFA928",
            textColor: "#000000"
        },
        medium: {
            color: "#FFDB5D",
            textColor: "#000000"
        },
        dark: {
            color: "#A66600",
            textColor: "#ffffff"
        },
        light: {
            color: "#FFE3B9",
            textColor: "#000000"
        }
    },
    3: {
        pure: {
            color: "#EF343B",
            textColor: "#000000"
        },
        medium: {
            color: "#ff6d66",
            textColor: "#000000"
        },
        dark: {
            color: "#b50014",
            textColor: "#ffffff"
        },
        light: {
            color: "#FFBEC0",
            textColor: "#000000"
        }
    },
    4: {
        pure: {
            color: "#5BDB3A",
            textColor: "#000000"
        },
        medium: {
            color: "#75E05A",
            textColor: "#000000"
        },
        dark: {
            color: "#008100",
            textColor: "#ffffff"
        },
        light: {
            color: "#D4F3CC",
            textColor: "#000000"
        }
    },
};
